//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionError from "./section-error";
import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "CheckboxSection",
  components: {
    SectionError
  },
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    toggler: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      //Legacy support [BS]
      default: false
    },
    checked: {
      type: null,
      //Legacy support [BS]
      default: false
    },
    multiLine: {
      type: Boolean,
      default: true
    },
    containerClass: {
      type: String,
      default: ""
    },
    trueValue: {
      type: Boolean,
      default: true
    },
    falseValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: {
    isChecked() {
      if (typeof this.checked === "string" && this.trueValue === false && this.falseValue === true) {
        return !this.checked === "true";
      } else if (typeof this.checked === "string") {
        return this.checked === "true";
      } else if (this.trueValue === false && this.falseValue === true) {
        return this.checked === null ? false : !this.checked;
      }
      return this.checked;
    }
  },
  methods: {
    handleInput(e) {
      if (this.stopPropagation) e.stopPropagation();
      if (this.trueValue === false && this.falseValue === true) {
        return this.$emit("change", !e.target.checked);
      }
      this.$emit("change", e.target.checked);
    }
  }
});